export default "__VITE_ASSET__CvxVlk4U__"